export default function(str) {
  if (typeof str === 'string' && str) {
    return JSON.parse(str);
  } else {
    return str;;
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/Form/parseJson.js